import React from 'react';
import PDFViewer from './Dicas&Servicos';
import pdfConfig from 'json/restaurantes.json'


const App = () => (
    <div>
        <PDFViewer pdfConfig={pdfConfig} />
    </div>
);

export default App;